import {
  ColorPicker as AntColorPicker,
  ColorPickerProps as AntColorPickerProps,
} from "antd";

type AntColorValue = Parameters<
  NonNullable<AntColorPickerProps["onChange"]>
>[0];

export type ColorPickerProps = Omit<
  AntColorPickerProps,
  "value" | "defaultValue" | "onChange"
> & {
  value?: string;
  onChange?: (value: string) => void;
};

export default function ColorPicker({
  value,
  onChange,
  ...rest
}: ColorPickerProps) {
  return (
    <AntColorPicker
      {...rest}
      value={value}
      onChange={(color: AntColorValue) => onChange?.(color.toHexString())}
    />
  );
}
